<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-switch-routes`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 4c5.523 0 10 4.477 10 10v22h2a1 1 0 01.492.13l.108.07a1 1 0 01.2 1.4l-4 5.333a1 1 0 01-1.6 0l-4-5.333A1 1 0 0136 36h2V14a6 6 0 00-11.996-.225L26 14v20c0 5.523-4.477 10-10 10S6 39.523 6 34V12H4a1 1 0 01-.8-1.6l4-5.333a1 1 0 011.6 0l4 5.333A1 1 0 0112 12h-2v22a6 6 0 0012 0V14c0-5.523 4.477-10 10-10z"/></svg>
</template>
<script>

export default {
  name: 'IconSwitchRoutes',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
